import css from 'styled-jsx/css'
import { colors } from '../../../styles'

export default css`
  .RestartStreamDialog {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    top: 0;
    background-size: cover;
  }
  .RestartStreamDialog img {
    width: 100%;
  }
  .control-dialog {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 16px;
    align-items: center;
    background-color: ${colors.cardDarkBg};
  }
  :global(.Overlay ) {
    padding: 0 !important;
    padding-top: 56.25% !important;
    position: relative !important;
    margin-bottom: 15px;
  }
`
